import React from 'react';
import styled, { css } from 'styled-components';

import BottomSheet from '@/components/molecules/bottom-sheet';
import MedicalCategory from '@/components/templates/f2f/common/medical-category';
import { CustomPageProps } from '@/types/app';
import { MedicalCategoryVo } from '@/types/hospital';

interface Props extends CustomPageProps {
  categories: MedicalCategoryVo[];
  toggleModal: () => void;
  onClick: (title: string) => void;
}

const MedicalCategoriesModal = ({ categories, toggleModal, client, onClick }: Props) => {
  if (client.isMobile) {
    return null;
  }

  return (
    <BottomSheet index={310} isOpened={true} onClickOverlay={toggleModal}>
      <PcContainer>
        <h4>진료과목 선택</h4>
        <CategoriesPCWrapper>
          {categories.map((category) => (
            <MedicalCategory
              name={category.name}
              imageUrl={category.iconUrl}
              key={`medical-category-${category.id}`}
              onClick={() => onClick(category.name)}
              description={category.description}
            />
          ))}
        </CategoriesPCWrapper>
      </PcContainer>
    </BottomSheet>
  );
};

export default MedicalCategoriesModal;

const PcContainer = styled.div`
  ${({ theme }) => css`
    width: 560px;
    display: flex;
    flex-direction: column;
    padding: 16px 12px 28px;
    & > h4 {
      ${theme.typography.UI20SB}
      color: ${theme.color.gray800};
      padding: 0 12px;
      margin-bottom: 16px;
    }
  `}
`;

const CategoriesPCWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  max-height: 610px;
  overflow-y: scroll;
`;
